export default __webpack_public_path__ + "static/media/area-systems.8f94f54b.svg";